// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".token-token-lists-wrapper{display:flex;align-items:center}", "",{"version":3,"sources":["webpack://./src/components/Common/TokenTokenLists/TokenTokenLists.scss"],"names":[],"mappings":"AAAA,2BACE,YAAA,CACA,kBAAA","sourcesContent":[".token-token-lists-wrapper {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
